import { createAction } from 'redux-actions'

export const getCards = createAction('GET_CARDS_STARTED')
export const getCardsSuccess = createAction('GET_CARDS_SUCCEED')
export const getCardsFail = createAction('GET_CARDS_FAILED')

export const createCard = createAction('CREATE_CARD_STARTED')
export const createCardSuccess = createAction('CREATE_CARD_SUCCEED')
export const createCardFail = createAction('CREATE_CARD_FAILED')

export const removeCard = createAction('REMOVE_CARD_STARTED')
export const removeCardSuccess = createAction('REMOVE_CARD_SUCCEED')
export const removeCardFail = createAction('REMOVE_CARD_FAILED')

export const getAddresses = createAction('GET_ADDRESSES_STARTED')
export const getAddressesSuccess = createAction('GET_ADDRESSES_SUCCEED')
export const getAddressesFail = createAction('GET_ADDRESSES_FAILED')

export const createAddress = createAction('CREATE_ADDRESS_STARTED')
export const createAddressSuccess = createAction('CREATE_ADDRESS_SUCCEED')
export const createAddressFail = createAction('CREATE_ADDRESS_FAILED')

export const updateAddress = createAction('UPDATE_ADDRESS_STARTED')
export const updateAddressSuccess = createAction('UPDATE_ADDRESS_SUCCEED')
export const updateAddressFail = createAction('UPDATE_ADDRESS_FAILED')

export const removeAddress = createAction('REMOVE_ADDRESS_STARTED')
export const removeAddressSuccess = createAction('REMOVE_ADDRESS_SUCCEED')
export const removeAddressFail = createAction('REMOVE_ADDRESS_FAILED')

export const getUserInfo = createAction('GET_USER_INFO_STARTED')
export const getUserInfoSuccess = createAction('GET_USER_INFO_SUCCEED')
export const getUserInfoFail = createAction('GET_USER_INFO_FAILED')



// WEBPACK FOOTER //
// ./src/store/actions/user.js